/**
 * InquiryFormInputs 에서 사용하는 className 모음.
 * 원본은 emotion styled 컴포넌트였고, Tailwind 전환 과정에서 문자열 상수로 바꿨다.
 */

export const inquiryInputsContainerClass = 'w-full';

export const inputItemListClass = 'flex flex-col';

/*
 * 원본의 &:not(:last-child) / &:not(:first-child) 를 임의 변형으로 그대로 옮긴다.
 * border-bottom 은 width(border-b) 와 color(border-b-*) 로 나뉘지만 서로 다른 속성이라
 * 같은 변형 단계에서도 충돌하지 않는다.
 * grid-cols-2 는 repeat(2, minmax(0,1fr)) 라 원본 `1fr 1fr`(=minmax(auto,1fr))과 다르므로
 * 임의 값으로 그대로 옮긴다.
 */
export const inputItemRowClass =
  'grid gap-[24px] [&:not(:first-child)]:pt-[40px] [&:not(:last-child)]:border-b [&:not(:last-child)]:border-b-apps-coreProductDivider [&:not(:last-child)]:pb-[40px] lg:grid-cols-[1fr_1fr]';

export const inputItemRowTitleClass =
  'text-[20px] font-bold leading-[160%] tracking-[-0.4px] text-apps-coreGray01 lg:col-span-2 lg:text-[22px] lg:tracking-[-0.44px]';
